import { render, staticRenderFns } from "./Zahlungseingang.vue?vue&type=template&id=230bf205"
import script from "./Zahlungseingang.vue?vue&type=script&lang=js"
export * from "./Zahlungseingang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports